import { useCallback, useEffect } from 'react'

import { doc, onSnapshot, type DocumentSnapshot } from 'firebase/firestore'

import { PROMPTER_COLLECTION } from '~shared/consts'

import { useRundown } from '@/features/rundown/rundown.derived'

import { db } from '../../firebase.js'
import { createPrompter } from '../../firestore.js'

export const usePrompterListener = (
  callback: (snapshot: DocumentSnapshot) => void,
) => {
  const rundown = useRundown()
  const rundownId = rundown.id
  const prompterId = rundown.prompterId

  const handleCreatePrompter = useCallback(async () => {
    await createPrompter(rundownId)
  }, [rundownId])

  // useEffect: Firestore subscription to the prompter doc, resubscribed when
  // the rundown's prompterId changes. External side effect, no alternative.
  useEffect(() => {
    if (!prompterId) {
      void handleCreatePrompter()
      return
    }

    return onSnapshot(doc(db, PROMPTER_COLLECTION, prompterId), callback)
  }, [callback, handleCreatePrompter, prompterId])
}
